<template>
  <tbody class="table-tab__tbody">
   <tr v-for="bid in bids">
     <th class="table-tab__th table-tab__color u-hr-underline text-nowrap" v-if="lot.permissions.CAN_CHECK_PUBLIC_LOT_REQUEST">
       <router-link class="table-tab__color u-text-underline"
                    :to="{name: 'purchases-public-lot-alien-bid', params: { lotId: lot.id, requestId: request.num, bidId: bid.id, tab: 'bid'}}">
         {{lot.catalog.name}} - {{request.num}} - {{bid.num}}
       </router-link>
     </th>
     <th class="table-tab__th" v-else>
       {{lot.catalog.name}} - {{request.num}} - {{bid.num}}
     </th>
     <td>{{bid.organization}}</td>
     <td>
       {{$t(request.state.label)}}
       <template v-if="request.stateShouldBeConfirmed">
         <br>
         <p class="u-red-color">{{$t('form.lot.confirming-request-status', [$t(request.confirmingState.label)])}}</p>
       </template>
     </td>
     <td>
       {{$t(bid.state.label)}}
       <template v-if="bid.stateShouldBeConfirmed">
         <br>
         <p class="u-red-color">{{$t('form.lot.confirming-request-status', [$t(bid.confirmingState.label)])}}</p>
       </template>
     </td>
     <template v-for="item in bid.criteria">
       <td>
         {{item|estimation}}
       </td>
     </template>
     <td class="text-nowrap" v-if="hasPrice">{{ bid.price | price}}</td>
     <td v-if="hasCurrency">{{$t(lot.method.REDUCTION ? lot.currency.label : bid.currencyBid.label)}}</td>
     <td v-if="hasCurrencyContract">{{$t(bid.currencyPay.label)}}</td>
     <td class="text-nowrap" v-if="hasPresentPrice">{{bid.presentPrice|price}}</td>
     <td v-if="hasFinalEstimate">{{bid.estimate|finalEstimation}}</td>
     <td v-if="hasFinalEstimate">{{bid.rank}}</td>
     <td></td>
     <td></td>
   </tr>
  </tbody>
</template>

<script>
  export default {
    props: {
      lot: Object,
      request: Object,
      serial: Number
    },

    computed: {
      bids() {
        return this.request.bids.map(b => ({
          ...this.request,
          ...b,
          criteria: this.criteria.map(c => {
            return _.get(_.find(b.criterions, { criterion : c.criterion }), 'estimate');
          })
        }))
      },

      criteria() {
        return [].concat(this.lot.criteria.expert.filter(c => !c.unit || !c.unit.CATALOG))//, this.lot.criteria.reducedPrice);
      },

      hasPrice() {
        return _.some(this.lot.requests, r => _.some(r.bids, b => b.price !== undefined));
      },

      hasCurrency() {
        return _.some(this.lot.requests, r => _.some(r.bids, b => b.currencyBid !== undefined));
      },

      hasCurrencyContract() {
        return !this.lot.method.REDUCTION && _.some(this.lot.requests, r => _.some(r.bids, b => b.currencyPay !== undefined));
      },

      hasPresentPrice() {
        return !this.lot.method.REDUCTION && _.some(this.lot.requests, r => _.some(r.bids, b => b.presentPrice !== undefined));
      },

      hasFinalEstimate() {
        return !this.lot.method.REDUCTION && _.some(this.lot.requests, r => _.some(r.bids, b => b.estimate !== undefined));
      }
    }
  }
</script>

<style scoped>

</style>
